import React from 'react';
export function Header() {
  return <header className="w-full py-4 px-6 md:px-12 bg-white border-b border-cream flex justify-between items-center sticky top-0 z-50" data-id="element-58">
      <div className="flex items-center" data-id="element-59">
        <img src="https://cdn.magicpatterns.com/uploads/uRbkKVm2QnsBqNb5EX25cD/Queen_co_boat_company_logo.png" alt="Queen Boat Co." className="h-16 object-contain" data-id="element-60" />
      </div>
      <nav className="hidden md:flex space-x-8 text-navy font-medium" data-id="element-61">
        <a href="https://www.lakegeorgeboating.com/" className="hover:text-copper transition-colors" data-id="element-62">
          Home
        </a>
        <a href="https://www.lakegeorgeboating.com/marina-services" className="hover:text-copper transition-colors" data-id="element-63">
          Marina Services
        </a>
        <a href="#" className="text-copper border-b-2 border-copper pb-1" data-id="element-64">
          Pre-Owned Boats
        </a>
        <a href="https://www.lakegeorgeboating.com/contact" className="hover:text-copper transition-colors" data-id="element-65">
          Contact
        </a>
      </nav>
      <div className="md:hidden flex items-center" data-id="element-66">
        <button className="text-navy" data-id="element-67">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-68">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" data-id="element-69" />
          </svg>
        </button>
      </div>
    </header>;
}